import { Menu } from 'antd-v4'
import React from 'react'

export const IncludeOutOfStockMenu = (
  onClick: (includeOutOfStock: boolean) => void,
  includeOutOfStock: boolean,
) => (
  <Menu onClick={({ key }) => onClick(key === 'true')}>
    <Menu.Item key='true' disabled={includeOutOfStock}>
      all
    </Menu.Item>
    <Menu.Item key='false' disabled={!includeOutOfStock}>
      in-stock only
    </Menu.Item>
  </Menu>
)
